import { render, staticRenderFns } from "./SortPop.vue?vue&type=template&id=719b19ac&scoped=true&"
import script from "./SortPop.vue?vue&type=script&lang=js&"
export * from "./SortPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b19ac",
  null
  
)

export default component.exports